var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChair({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 22.668V26.668M24.5 22.668V26.668",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 12.0007V8.00065C5.8335 6.52789 7.0274 5.33398 8.50016 5.33398H24.5002C25.973 5.33398 27.1668 6.52789 27.1668 8.00065V12.0007",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 12.002C4.36041 12.002 3.1665 13.1959 3.1665 14.6686C3.1665 15.6557 3.70277 16.5174 4.49984 16.9785V20.002C4.49984 21.4748 5.69374 22.6686 7.1665 22.6686H25.8332C27.306 22.6686 28.4998 21.4748 28.4998 20.002V16.9785C29.2969 16.5174 29.8332 15.6557 29.8332 14.6686C29.8332 13.1959 28.6393 12.002 27.1665 12.002C25.6937 12.002 24.4998 13.1959 24.4998 14.6686V18.002C24.4998 18.3701 24.2013 18.6686 23.8332 18.6686H9.1665C8.79832 18.6686 8.49984 18.3701 8.49984 18.002V14.6686C8.49984 13.1959 7.30593 12.002 5.83317 12.002Z",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.9dea15aef1867decfabf23d6d51fcd8a.svg";
export { ForwardRef as ReactComponent };